export const OWNER_STATUS_ACTIVE = 'active'
export const OWNER_STATUS_ARCHIVE = 'archive'
